import { appQueryParameters } from '@clubmed/utils';

import { ICONS } from 'Components/utils/icon/icons';

export const ADULTS_ONLY_FACET_ID = 'facette_adult_only';
export const ADULTS_NUMBER_MIN = 1;
export const ADULTS_NUMBER_MAX = 6;
export const AREA_FACET_PREFIX_ID = 'AREA';
export const CHILDCARE_FACET_ID = 'facette_childcare_age_in_month';
export const COUNTRY_FACET_PREFIX_ID = 'COUNTRY';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_DEPARTURE_CITY_VALUE = 'NO';
export const DEPARTURE_CITY_FACET_ID = 'facette_departure_city';
export const DEPARTURE_DATE = 'date';
export const DEPARTURE_DATE_MAX_DATE = {
  years: 2,
};
export const DEPARTURE_DATE_MAX_FACET_ID = 'departure_date_max';
export const DEPARTURE_DATE_MIN_FACET_ID = 'departure_date_min';
export const DEPARTURE_DATE_DEFAULT_DELAY_IN_MONTH = 6;
export const DURATION_FACET = 'facette_duration';
export const KIDS_FACET_ID = 'facette_kids';
export const KIDS_NUMBER_MAX = 5;
export const LOCALE_FACET_ID = 'locale';
export const MAX_NUMBER_OF_SELECTED_PRODUCTS = 3;
export const OFFER_ID_FACET_ID = 'facette_offer_id';
export const PRODUCT_FACET_ID = 'product_id';
export const WHEN_FACET_ID = 'facette_when';
export const WHERE_FACET_ID = 'facette_where';
export const ACTIVITIES_FACET_ID = 'activities_tree';
export const DESTINATIONS_FACET_ID = 'destinations_tree';
export const COUNTRIES_FACET_ID = 'facette_destination_country';
export const TYPES_OF_STAY_FACET_ID = 'facette_type';
export const FACET_COMFORT_ID = 'facette_comfort_label';
export const QUERY_QUERY_PARAM = 'search';
export const PRODUCTS_TO_COMPARE_QUERY_PARAM = appQueryParameters.productsComparison.productIds;
export const FACET_QUERY_PARAMS = [
  { id: 'destination', facetId: COUNTRIES_FACET_ID },
  { id: 'departure_city', facetId: DEPARTURE_CITY_FACET_ID },
];
export const DEFAULT_CHILDCARE_FACETS = ['132-215', '24-47', '4-23', '48-131'];

export const FILTERABLE_FACETS_IDS = [
  ACTIVITIES_FACET_ID,
  DESTINATIONS_FACET_ID,
  COUNTRIES_FACET_ID,
  TYPES_OF_STAY_FACET_ID,
  FACET_COMFORT_ID,
];

type FacetTrackingConfig = {
  id: stringify,
  trackingPrefixLabel?: string,
};

export const FILTERABLE_FACETS_TRACKING_CONFIG: Array<FacetTrackingConfig> = [
  {
    id: ACTIVITIES_FACET_ID,
    trackingPrefixLabel: 'activities',
  },
  {
    id: DESTINATIONS_FACET_ID,
    trackingPrefixLabel: 'destinations',
  },
  {
    id: COUNTRIES_FACET_ID,
    trackingPrefixLabel: 'destinations',
  },
  {
    id: TYPES_OF_STAY_FACET_ID,
    trackingPrefixLabel: 'typeofstay',
  },
  {
    id: FACET_COMFORT_ID,
    trackingPrefixLabel: 'comfort',
  },
];

type FacetListConfig = {
  deep?: boolean,
  id: stringify,
  facetLabels?: string,
  titleLabel?: string,
};

export type FacetTemplateConfig = {
  dataLabel?: string,
  facetLists: Array<FacetListConfig>,
  iconName?: string,
  id: stringify,
  titleLabel?: string,
};

export const FILTERABLE_FACETS_TEMPLATE_CONFIG: Array<FacetTemplateConfig> = [
  {
    id: DESTINATIONS_FACET_ID,
    dataLabel: 'where',
    iconName: ICONS.EARTH_PLANE,
    facetLists: [
      {
        deep: false,
        id: DESTINATIONS_FACET_ID,
        titleLabel: 'faceting.where.destinationTitle',
      },
      {
        deep: false,
        id: COUNTRIES_FACET_ID,
        titleLabel: 'faceting.where.countriesTitle',
      },
    ],
    titleLabel: 'faceting.where.title',
  },
  {
    id: ACTIVITIES_FACET_ID,
    dataLabel: 'activities',
    facetLists: [{ deep: true, id: ACTIVITIES_FACET_ID }],
    iconName: ICONS.ACTIVITIES,
    titleLabel: 'faceting.activities.title',
  },
  {
    id: TYPES_OF_STAY_FACET_ID,
    dataLabel: 'typeofstay',
    facetLists: [{ deep: false, id: TYPES_OF_STAY_FACET_ID, facetLabels: 'faceting.typesOfStay' }],
    iconName: ICONS.BEACH,
    titleLabel: 'faceting.typesOfStay.title',
    trackingPrefixLabel: 'typeofstay',
  },
  {
    id: FACET_COMFORT_ID,
    dataLabel: 'comfort',
    facetLists: [{ deep: false, id: FACET_COMFORT_ID }],
    iconName: ICONS.TRIDENT1,
    titleLabel: 'faceting.comfort.title',
  },
];

export const FACETS = {
  when: 'when',
  who: 'who',
  where: 'where',
};
